import Clickable from '@ms/yammer-web-core-ui/dist/components/Clickable';
import CoordinatedTooltip, { DirectionalHint } from '@ms/yammer-web-core-ui/dist/components/CoordinatedTooltip';
import Flex from '@ms/yammer-web-core-ui/dist/components/Flex';
import { PanelLeftText20Regular } from '@ms/yammer-web-core-ui/dist/components/FluentUISystemIcon';
import type { FC } from 'react';
import React from 'react';

export interface CollapseIconButtonProps {
  readonly ariaLabel: string;
  readonly ariaExpanded: boolean;
  readonly height: number;
  readonly onClick: () => void;
}

const CollapseIconButton: FC<CollapseIconButtonProps> = ({ ariaLabel, ariaExpanded, height, onClick }) => (
  <CoordinatedTooltip content={ariaLabel} directionalHint={DirectionalHint.leftCenter}>
    <Clickable
      ariaLabel={ariaLabel}
      ariaExpanded={ariaExpanded}
      unstyled={true}
      display="inline-block"
      onClick={onClick}
    >
      <Flex alignItems="center" justifyContent="center" height={height} paddingLeft={1.5} paddingRight={1.5}>
        <PanelLeftText20Regular />
      </Flex>
    </Clickable>
  </CoordinatedTooltip>
);

export default CollapseIconButton;
